import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'

// The estimated size of a card. Used for virtualization.
export const CARD_SIZE_ESTIMATE = 125
// Vertical gap between cards
export const CARD_MARGIN_BOTTOM = 8
// Padding between column and cards
export const COLUMN_PADDING = 4

export const COLUMN_STYLE: BetterSystemStyleObject = {
  borderRadius: 2,
  transition: 'transform 75ms',
  border: '1px solid',
  borderColor: 'border.default',
}
